import { render, staticRenderFns } from "./LicitacaoAtualizacaoAcoesAlterarDados.vue?vue&type=template&id=1946706d&scoped=true"
import script from "./LicitacaoAtualizacaoAcoesAlterarDados.vue?vue&type=script&lang=js"
export * from "./LicitacaoAtualizacaoAcoesAlterarDados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1946706d",
  null
  
)

export default component.exports